import { formatInTimeZone } from 'date-fns-tz';
import { get } from 'lodash';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import useNfd from '../hooks/useNfd';
import useRaffleOwner from '../hooks/useRaffleOwner';
import formatNumber from '../utils/formatNumber';
import ProfileAvatar from './ProfileAvatar';

function RowTransaction({ entry, raffle }) {
  const raffleOwner = useRaffleOwner(raffle?.owner);
  const { getNfd } = useNfd();
  const [wallet, setWallet] = useState(null);
  const senderAddress = entry?.transaction?.sender;

  useEffect(() => {
    if (!senderAddress) return;

    (async () => {
      try {
        const nfd = await getNfd(senderAddress);
        if (nfd) {
          return setWallet(get(nfd, 'name'));
        }
        setWallet(`${senderAddress?.slice(0, 4)}...${senderAddress?.slice(-4)}`);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [senderAddress]);

  return (
    <tr key={entry.id} className='rounded-md hover:bg-bg'>
      <td className='py-2 font-medium text-text whitespace-nowrap'>
        <a href={`https://allo.info/tx/${entry?.transaction?.id}`} target='_blank' rel='noreferrer' className='px-3'>
          {entry?.transaction?.id.slice(0, 4)}...{entry?.transaction?.id.slice(-4)}
        </a>
      </td>
      <td className='py-2 font-medium text-text whitespace-nowrap'>
        <Link href={`/profile/${entry?.address}`}>
          <a className='flex items-center'>
            {wallet && (
              <div className='flex items-center mr-2'>
                <ProfileAvatar width={25} address={senderAddress} />
              </div>
            )}

            <span>{wallet}</span>
          </a>
        </Link>
      </td>
      <td className='py-2 font-medium text-text whitespace-nowrap'>
        <a href={`https://allo.info/tx/${entry?.transaction?.id}`} target='_blank' rel='noreferrer' className='px-3'>
          {formatInTimeZone(new Date(entry?.transaction?.['round-time'] * 1000), 'America/New_York', 'MMM dd hh:mm aaa')}
        </a>
      </td>
      <td className='py-2 font-medium text-center text-text whitespace-nowrap '>
        <a href={`https://allo.info/tx/${entry?.transaction?.id}`} target='_blank' rel='noreferrer' className='pr-8'>
          {formatNumber(entry?.tickets || 0)}
        </a>
      </td>
      <td className='py-2 font-medium text-center text-text whitespace-nowrap '>
        <a href={`https://allo.info/tx/${entry?.transaction?.id}`} target='_blank' rel='noreferrer' className='pr-8'>
          {formatNumber((entry?.transaction?.['asset-transfer-transaction']?.amount || 0) / raffleOwner.divisible || 1)} {raffleOwner.tokenAbbr}
        </a>
      </td>
    </tr>
  );
}

export default RowTransaction;
